import React from "react";
import Avatar from "@material-ui/core/Avatar";
import classNames from "classnames";
import StringFormat from "../../../util/string-format";
import teamLogoStyles from "../styles/TeamLogoStyles";
import { invertColor } from "../../../util/object-util";

const TeamAvatar = ({
	showBackgroundColor = true,
	variant = "rounded",
	size = "medium",
	logo,
	teamName,
	color
}) => {
	const backgroundColor = color || "#FFF";
	const textColor = invertColor(backgroundColor, true);
	const classes = teamLogoStyles({
		backgroundColor,
		textColor,
		variant,
		showBackgroundColor
	});

	return (
		<Avatar
			variant={variant}
			src={logo}
			alt={`${teamName} logo`}
			className={classNames(classes.avatar, {
				[classes.avatarLarge]: size === "large",
				[classes.avatarSmall]: size === "small"
			})}
		>
			{StringFormat.getInitials(teamName)}
		</Avatar>
	);
};

export default TeamAvatar;
